function clean(value: unknown) {
  return String(value == null ? '' : value).trim();
}

function capitalizeFirstLetter(value: string) {
  return value ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : value;
}

export function getEmailLocalPart(email: unknown) {
  const value = clean(email);
  const atIndex = value.indexOf('@');
  if (atIndex <= 0) return value;
  return value.slice(0, atIndex).trim() || value;
}

export function getAccountDisplayName(displayName?: string | null, email?: string | null) {
  const name = clean(displayName);
  if (name) {
    return capitalizeFirstLetter(name.includes('@') ? getEmailLocalPart(name) : name);
  }

  const emailValue = clean(email);
  if (emailValue) return capitalizeFirstLetter(getEmailLocalPart(emailValue));

  return '';
}
